// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum BlockedTenantReason {
    UNSPECIFIED = 'UNSPECIFIED',
    SUSPECTEDSUBLETTING = 'SUSPECTED_SUB_LETTING',
    OUTSTANDINGCHARGES = 'OUTSTANDING_CHARGES',
    ILLEGALACTIVITY = 'ILLEGAL_ACTIVITY',
    SUSPICIOUSREFERENCING = 'SUSPICIOUS_REFERENCING',
    FRAUD = 'FRAUD'
}



